import { useQuery } from 'react-query'
import { IUser} from '../common/types'
import { getUser } from '../service/user'

export const useUser = () => {

  // Query
  return useQuery<IUser | undefined>('user', getUser)
}